import type { CityConfig } from "../city-template/types";

export const fultonMOConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Fulton",
  state: "Missouri",
  stateAbbr: "MO",
  slug: "fulton-mo",
  route: "/cities/fulton-mo",
  title: "Emergency Passport Fulton, MO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Fulton, MO — as fast as 24 hours. Serving Callaway County and the Westminster College community. A+ BBB rated registered State Dept. courier serving Fulton, Columbia, Jefferson City, and central Missouri. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Fulton, MO",
  heroSubtitle: "Westminster College student heading to study abroad at Oxford and your passport expired? Callaway County business trip to Germany with two weeks notice? Churchill Museum visitors discovering they need fast documents for international travel? We help Fulton residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Fulton%20Missouri%20Callaway%20County%20Westminster%20College%20campus%20historic%20red%20brick%20collegiate%20buildings%20National%20Churchill%20Museum%20Breakthrough%20sculpture%20from%20the%20Berlin%20Wall%20Americas%20National%20Churchill%20Museum%20landmark%20columns%20and%20Brick%20District%20historic%20downtown%20central%20Missouri%20college%20town%20golden%20hour%20warm%20light%20professional%20drone%20photography%20Heartland%20heritage%20and%20education&width=1800&height=700&seq=fulton-mo-hero-2026&orientation=landscape",
  heroImageAlt: "Fulton Missouri Westminster College campus with Churchill Museum and Brick District at golden hour",
  geoPosition: "38.8467;-91.9479",
  geoPlacename: "Fulton, Missouri",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 350 miles northeast of Fulton — the nearest regional passport agency to central Missouri",
  },
  nearbyCitiesZips: [
    { name: "Fulton", zips: "65251" },
    { name: "Columbia", zips: "65201, 65202, 65203" },
    { name: "Jefferson City", zips: "65101, 65109" },
    { name: "New Bloomfield", zips: "65063" },
    { name: "Mexico", zips: "65265" },
    { name: "Auxvasse", zips: "65231" },
    { name: "Holts Summit", zips: "65043" },
    { name: "Moberly", zips: "65270" },
    { name: "Ashland", zips: "65010" },
    { name: "Centralia", zips: "65240" },
    { name: "Mokane", zips: "65059" },
    { name: "Kingdom City", zips: "65262" },
    { name: "Hallsville", zips: "65255" },
    { name: "Montgomery City", zips: "63361" },
    { name: "Fayette", zips: "65248" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Callaway County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "College & Capitol Hub", desc: "Serving Westminster College, Callaway County, and mid-Missouri" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Columbia, MO", route: "/cities/columbia-mo" },
    { name: "Fast passport renewal in Jefferson City, MO", route: "/cities/jefferson-city" },
    { name: "Emergency passport help in St. Louis, MO", route: "/cities/st-louis" },
    { name: "Urgent passport services in Kansas City, MO", route: "/cities/kansas-city" },
    { name: "Passport courier services in Springfield, MO", route: "/cities/springfield-mo" },
    { name: "Same-day passport help in Chicago, IL", route: "/cities/chicago" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Fulton remotely via secure courier. We do not have a walk-in office in Fulton — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Callaway County, Westminster College Blue Jays, and central Missouri.",
  fpcOfficeAddress: "1200 Main St, Kansas City, Missouri 64105",
  fpcOfficeDistance: "Serving all of Callaway County including Fulton, New Bloomfield, Auxvasse, Holts Summit, and the mid-Missouri region",
  serviceAreaIntro: "From the historic campus of Westminster College — where Winston Churchill delivered his famous Iron Curtain speech — and the National Churchill Museum with its Berlin Wall Breakthrough sculpture to the charming Brick District of downtown Fulton, from the rolling farmlands of Callaway County to the nearby state capital in Jefferson City and the University of Missouri in Columbia — Fast Passport Center serves the entire central Missouri region. We regularly help Westminster College students studying abroad at Oxford, Callaway County families, and mid-Missouri business travelers get their passports fast without the drive to St. Louis or Chicago.",
  nearbyCitiesIntro: "We serve all Fulton neighborhoods and the surrounding area including New Bloomfield, Auxvasse, Holts Summit, and beyond. If you are anywhere in Callaway County, Boone County, or Cole County, we have you covered.",
  howItWorksIntro: "Most Fulton travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Fulton travelers need to navigate the passport appointment system — the nearest regional agency (Chicago) is 350 miles away. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Fulton and Callaway County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Fulton? Here are the most common ones we hear from Callaway County travelers.",
  statePageRoute: "/states/missouri",
  statePageName: "Missouri",
  dmvWebsite: "https://dor.mo.gov/drivers/",
  dmvLabel: "Missouri DOR — Driver License Bureau",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Fulton travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Emily S.",
      location: "Fulton, MO",
      rating: 5,
      text: "Westminster College student — got accepted to the Oxford summer program with 6 days before flight. Fast Passport Center got my renewal in 26 hours. From Churchill's Iron Curtain speech site to Churchill's England. This service is pure Blue Jay magic!",
      service: "Passport Renewal",
    },
    {
      name: "Mark T.",
      location: "Holts Summit, MO",
      rating: 5,
      text: "State government business trip to South Korea. Realized my passport had expired 5 days before departure. Fast Passport Center handled everything in 28 hours. Never left Callaway County. Absolutely incredible service for mid-Missouri professionals!",
      service: "Emergency Passport",
    },
    {
      name: "Patricia L.",
      location: "New Bloomfield, MO",
      rating: 5,
      text: "Family trip to Paris and both boys needed first passports. Fast Passport Center walked us through child passport applications — all done in 4 days. Callaway County families, stop searching — this is the passport service you've been looking for!",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "fulton-1",
      name: "Fulton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "301 Court St",
      city: "Fulton",
      state: "MO",
      zip: "65251",
      phone: "(573) 642-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Fulton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Fulton facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "fulton-2",
      name: "Callaway County Circuit Clerk",
      type: "County Government Passport Acceptance",
      address: "10 E 5th St",
      city: "Fulton",
      state: "MO",
      zip: "65251",
      phone: "(573) 642-0780",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Downtown Fulton Courthouse",
      website: "https://www.callawaycounty.org",
      websiteLabel: "Callaway County Circuit Clerk",
      notes: "County seat with passport acceptance services. Good alternative to post office. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "fulton-3",
      name: "Columbia Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "511 E Walnut St",
      city: "Columbia",
      state: "MO",
      zip: "65201",
      phone: "(573) 442-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "25 miles north of Fulton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major USPS facility in Columbia. Full passport services available. Appointment strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "fulton-4",
      name: "Jefferson City Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "131 W High St",
      city: "Jefferson City",
      state: "MO",
      zip: "65101",
      phone: "(573) 636-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "25 miles south of Fulton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "State capital facility serving Cole County. Full passport services available. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "fulton-5",
      name: "Mexico Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "300 E Monroe St",
      city: "Mexico",
      state: "MO",
      zip: "65265",
      phone: "(573) 581-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "30 miles northeast of Fulton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Audrain County area. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 6 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Fulton photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Callaway County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Fulton and Westminster College applicants show up with incorrect payment and have to reschedule.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Westminster College staff and Callaway County families.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Fulton travelers often assume a regional agency is close enough. At 350 miles away (Chicago), appointments are scarce. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Fulton." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Fulton address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Fulton before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Fulton for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — even faster than driving to St. Louis." },
    { q: "How fast can I renew my passport in Fulton?", a: "Fast Passport Center offers fast passport renewal in Fulton in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Fulton?", a: "The nearest regional passport agency to Fulton is the Chicago Passport Agency at 230 S Dearborn St, Suite 380, Chicago, IL 60604, approximately 350 miles northeast. Appointments are still hard to get. Fast Passport Center's registered courier service achieves 24–48 hour turnaround without any in-person agency visit." },
    { q: "Do you serve Westminster College students?", a: "Absolutely. Fast Passport Center is a favorite of Westminster College Blue Jays! We provide expedited passport services for study abroad programs — especially the Oxford summer program that Churchill made famous — as well as international conference travel and spring break trips abroad." },
    { q: "Is there a regional passport agency near Fulton?", a: "The Chicago Passport Agency at 230 S Dearborn St, Suite 380, Chicago, IL 60604 is about 350 miles from Fulton, making it the closest regional agency. Appointments are extremely limited, require documented life-or-death emergencies, and you'll likely wait all day. Fast Passport Center's courier service is faster, more reliable, and requires no drive." },
    { q: "Do you serve Jefferson City and Columbia from Fulton?", a: "Absolutely. Fast Passport Center serves the entire mid-Missouri region including Fulton, Jefferson City, Columbia, Holts Summit, New Bloomfield, and all surrounding communities. Our courier service works from any address in Callaway, Cole, or Boone counties." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Fulton with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Can I expedite a child passport in Fulton?", a: "Yes. Fast Passport Center expedites child passports in Fulton for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Callaway County and Westminster College families through the entire process." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Fulton", address: "1701 N Bluff St, Fulton, MO 65251", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "Walgreens — Fulton", address: "800 N Bluff St, Fulton, MO 65251", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "Walmart Supercenter — Jefferson City", address: "724 W Stadium Blvd, Jefferson City, MO 65109", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "Walmart Supercenter — Columbia", address: "415 Conley Rd, Columbia, MO 65201", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
  ],
  dmvLocations: [
    {
      name: "Missouri DOR — Fulton License Office",
      address: "200 Market St, Fulton, MO 65251",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services. Most convenient for Fulton and Callaway County residents.",
      featured: true,
    },
    {
      name: "Missouri DOR — Jefferson City License Office",
      address: "301 W High St, Jefferson City, MO 65101",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Cole County. REAL ID available. Appointment recommended.",
      featured: false,
    },
    {
      name: "Missouri DOR — Columbia License Office",
      address: "403 Vandiver Dr, Columbia, MO 65202",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Boone County and MU community. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "COU",
      name: "Columbia Regional Airport",
      distance: "20 miles north of Fulton",
      address: "11300 S Airport Dr, Columbia, MO 65201",
      note: "Regional airport with connections to major hubs. About 25 minutes from Fulton via US-63.",
      flightUrl: "https://www.flycou.com/",
      flightLabel: "COU Airport",
      featured: true,
    },
    {
      code: "STL",
      name: "St. Louis Lambert International Airport",
      distance: "110 miles east of Fulton",
      address: "10701 Lambert International Blvd, St. Louis, MO 63145",
      note: "Major international airport with worldwide connections. About 1 hour 40 minutes from Fulton via I-70.",
      flightUrl: "https://www.flystl.com/",
      flightLabel: "STL Airport",
      featured: false,
    },
    {
      code: "MCI",
      name: "Kansas City International Airport",
      distance: "150 miles west of Fulton",
      address: "1 Kansas City Blvd, Kansas City, MO 64153",
      note: "Major international airport. About 2 hours 20 minutes from Fulton via I-70.",
      flightUrl: "https://www.flykci.com/",
      flightLabel: "MCI Airport",
      featured: false,
    },
  ],
};